'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isUrl = require('is-url');

var _isUrl2 = _interopRequireDefault(_isUrl);

var _toPascalCase = require('to-pascal-case');

var _toPascalCase2 = _interopRequireDefault(_toPascalCase);

var _slateReact = require('slate-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A Slate plugin to add soft breaks on return.
 *
 * @param {Object} options
 *   @property {String} type
 *   @property {String} hrefProperty
 *   @property {String} collapseTo
 * @return {Object}
 */

function PasteLinkify() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$type = options.type,
      type = _options$type === undefined ? 'link' : _options$type,
      _options$hrefProperty = options.hrefProperty,
      hrefProperty = _options$hrefProperty === undefined ? 'href' : _options$hrefProperty;


  function hasLinks(value) {
    return value.inlines.some(function (inline) {
      return inline.type == type;
    });
  }

  function unwrapLink(change) {
    change.unwrapInline(type);
  }

  function wrapLink(change, href) {
    change.wrapInline({
      type: type,
      data: _defineProperty({}, hrefProperty, href)
    });
  }

  return {
    onPaste: function onPaste(event, change) {
      var transfer = (0, _slateReact.getEventTransfer)(event);
      var value = change.value;
      var text = transfer.text;

      if (transfer.type !== 'text' && transfer.type !== 'html') return;
      if (!(0, _isUrl2.default)(text)) return;

      if (value.isCollapsed) {
        var startOffset = value.startOffset;

        change.insertText(text).moveOffsetsTo(startOffset, startOffset + text.length);
      } else if (hasLinks(value)) {
        change.call(unwrapLink);
      }

      change.call(wrapLink, text);

      if (options.collapseTo) {
        change['collapseTo' + (0, _toPascalCase2.default)(options.collapseTo)]();
      }

      return change;
    }
  };
}

/**
 * Export.
 *
 * @type {Function}
 */

exports.default = PasteLinkify;